import {
  Module,
  VuexModule,
  Mutation,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";
import { CATEGORY_UNKNOWN_ID, CATEGORY_COM_BOX_ID, HYDRY_MINI_ID, createDefaultDeviceSettings, createUnknownCategory, createMiniTemplate, DeviceCategoriesAndTemplates, DeviceSettingsJson } from "@/data/models/DeviceSettingsManager";

const name = "deviceCategoriesAndTemplates";

/**
 * Ensures that the HyDry Mini template exists in the ComBox category.
 * If the Mini template is missing (e.g. settings were saved before Mini support),
 * it is injected into the ComBox category's device templates.
 */
function ensureMiniTemplateExists(deviceSettingsJson: DeviceSettingsJson) {
  const comBoxCategory = deviceSettingsJson.deviceCategories.find(
    (cat) => cat.id === CATEGORY_COM_BOX_ID
  );

  if (comBoxCategory) {
    const hasMiniTemplate = comBoxCategory.deviceTemplates.some(
      (template) => template.id === HYDRY_MINI_ID
    );

    if (!hasMiniTemplate) {
      comBoxCategory.deviceTemplates.push(createMiniTemplate());
    }
  }
}

@Module({ dynamic: true, namespaced: true, store, name: name })
export class DeviceCategoriesAndTemplatesVuexModule extends VuexModule {
  localDeviceCategoriesAndTemplates: DeviceSettingsJson = createDefaultDeviceSettings();
  sharedDeviceCategoriesAndTemplates: DeviceSettingsJson = createDefaultDeviceSettings();

  @Mutation
  setLocalDeviceCategoriesAndTemplates(deviceCategoriesAndTemplates: DeviceCategoriesAndTemplates) {
    const deviceSettingsJson = JSON.parse(deviceCategoriesAndTemplates.deviceSettingsJson) as DeviceSettingsJson;

    if (
      !deviceSettingsJson.deviceCategories.find((cat) => {
        return cat.id === CATEGORY_UNKNOWN_ID;
      })
    ) {
      deviceSettingsJson.deviceCategories.push(createUnknownCategory());
    }

    ensureMiniTemplateExists(deviceSettingsJson);

    this.localDeviceCategoriesAndTemplates = deviceSettingsJson;
  }

  @Mutation
  setSharedDeviceCategoriesAndTemplates(deviceCategoriesAndTemplates: DeviceCategoriesAndTemplates) {
    const deviceSettingsJson = JSON.parse(deviceCategoriesAndTemplates.deviceSettingsJson) as DeviceSettingsJson;

    if (
      !deviceSettingsJson.deviceCategories.find((cat) => {
        return cat.id === CATEGORY_UNKNOWN_ID;
      })
    ) {
      deviceSettingsJson.deviceCategories.push(createUnknownCategory());
    }

    ensureMiniTemplateExists(deviceSettingsJson);

    this.sharedDeviceCategoriesAndTemplates = deviceSettingsJson;
  }

  @Mutation
  clear() {
    this.localDeviceCategoriesAndTemplates = createDefaultDeviceSettings();
    this.sharedDeviceCategoriesAndTemplates = createDefaultDeviceSettings();
  }
}

export const DeviceCategoriesAndTemplatesModule = getModule(DeviceCategoriesAndTemplatesVuexModule, store);
